module.exports = __webpack_public_path__ + "static/img/102.4d48ce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/190926/102.jpg
// module id = PovB
// module chunks = 0